<template>
  <sf-debounced-textarea
    v-model="commentValue"
    class="pw-cart-row-comment"
    :label="label"
    :rows="1"
    auto-grow
    hide-details="auto"
    density="compact"
    variant="outlined"
    :rules="commentField.required ? [requiredForDebouncedFieldsRule] : []"
    :maxlength="maxLength"
    :readonly="!editable"
    autocomplete="off"
    :hint="commentValue.length >= maxLength ? $t('maxLength', [maxLength]) : ''"
    persistent-hint
    debounce-time="1s"
    @debounce="sendComment"
    @blur="sendComment"
  />
</template>

<script setup lang="ts">
import SfDebouncedTextarea from '@/components/input/SfDebouncedTextarea.vue'
import { requiredForDebouncedFieldsRule } from '@/rules'
import { CommentField, SellerComments } from '@/types/index'
import { PropType, computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  comment: {
    type: String,
    default: ''
  },
  commentField: {
    type: Object as PropType<CommentField>,
    required: true
  },
  fieldIndex: {
    type: String as PropType<keyof SellerComments>,
    default: ''
  },
  maxLength: {
    type: Number,
    required: true
  },
  editable: {
    type: Boolean,
    default: false
  },
  isSellerComment: {
    type: Boolean,
    default: true
  }
})
const emit = defineEmits<{
  (e: 'commentChanged', value: string, fieldIndex: keyof SellerComments): void
}>()

const { t } = useI18n()

const commentValue = ref(props.comment)

const sendComment = () => {
  if (props.editable) {
    emit('commentChanged', commentValue.value, props.fieldIndex)
  }
}

const label = computed(() => {
  let index = ''
  if (props.fieldIndex) {
    const fieldRegex = /field([1-6]+)/g
    index += ' ' + fieldRegex.exec(props.fieldIndex)?.[1]
  }

  let label = props.isSellerComment ? t('common.sellerComment') + index : t('cartPositionComment')

  if (props.commentField.label) {
    label = props.commentField.label
  }

  if (props.commentField.required) {
    label += ' *'
  }

  return label
})
</script>
